import _ from 'lodash'
import BaseStandardReportForm from '../common/base-standard-report-edit-form'
import DatasetReportTableModel from './dataset-report-table-model'
import DatasetFilters from 'scoreboard/datasets/dataset-filters'
import DatasetNotReady from 'scoreboard/datasets/not-available/dataset-not-ready'
import i18n from 'scoreboard/components/i18n'
import renderDefaultCalendarField from 'scoreboard/datasets/edit/render-default-calendar-field'
import $ from 'jquery'

const DatasetReportForm = BaseStandardReportForm.extend({

	recordTypeCode: 'datasets.records',

	initialize: function(options = {}) {
		BaseStandardReportForm.prototype.initialize.apply(this, arguments)

		this.dataset = this.model.get('dataset')
	},

	/** @override */
	banner: function() {
		let bannerMessageCode
		if (!this.options.embedded) {
			bannerMessageCode = 'report.designer.editInfoMessage'
			return i18n.get(bannerMessageCode, i18n.get(this.recordTypeCode))
		} else {
			// #52364 add a message with a link to the source dataset when
			// editing a dataset report that is embedded in a dashboard
			bannerMessageCode = 'report.designer.dialogEditInfoMessage'
			let link =
				`<a class="sp-navigate text-link" href="/datasets/${this.dataset.id}">${_.escape(this.dataset.get('label'))}</a>`
			let sourceMessage = i18n.get('report.designer.dialogEditInfoMessage.dataset', link)
			return sourceMessage + ' ' + i18n.get(bannerMessageCode, i18n.get(this.recordTypeCode))
		}
	},

	filterView: function(el, model) {
		let rowFilters = this.model.get('filters') || []
		let securityFilters = this.model.get('securityFilters') || []
		let combinedFilters = [].concat(rowFilters, securityFilters)

		this._filtersView = new DatasetFilters({
			el,
			model: this.dataset,
			//clone, so any intermediary changes to the filters aren't propagiated
			filters: _.cloneDeep(combinedFilters),
			header: i18n.get('report.wizard.filters'),
			noneMessage: i18n.get('common.thereAreNo', 'report.wizard.filters'),
			treeItemsById: this.model.treeItemsById,
			allowAdd: !this.model.hasEmptyDataset()
		})

		this._filtersView.on('change', filters => {
			//https://github.com/SpiderStrategies/Scoreboard/issues/40170#issuecomment-894386544
			this._clearTooltips()

			let rowFilters = _.filter(filters, f => _.isNil(f.permissionId))
			//update the model on the final change, because of the clone above
			//this will trigger a model change (which is what we want)
			this.model.set('filters', rowFilters)
		})

		return this._filtersView
	},

	_reportTableModel() {
		return DatasetReportTableModel
	},

	remove() {
		BaseStandardReportForm.prototype.remove.apply(this, arguments)
		_.invokeMap([this.notReadyView], 'remove')
	}


})

export default DatasetReportForm

DatasetReportForm.__filename__ = 'reports/dataset-report/dataset-report-form.js'
